import React from 'react';
import styles from './AboutUsStory.module.scss';

const AboutUsStory = () => {
    return (
        <section className={styles.section}>
            <div className={styles.contentWrapper}>
                <div className={styles.storyCard}>
                    <span className={styles.cardLabel}>THE FOUNDER'S STORY</span>
                    <div className={styles.storyBody}>
                        <p className={styles.paragraph}>
                            Three years ago, I started <a href="https://advprep.com" target="_blank" rel="noopener noreferrer" style={{ color: '#0257ef' }}>Advantage Prep</a> — a boutique SAT tutoring agency in Ho Chi Minh City.
                            Over those years, I worked closely with over 100 students. I saw brilliant, hardworking kids
                            plateau because the system wasn't built for them. Every student was different, but every course was the same.
                        </p>
                        <p className={styles.paragraph}>
                            I kept seeing the same archetype: students who invested thousands of dollars and hundreds of hours
                            into prep materials, courses, and tutors just only to feel lost, frustrated, and stuck at the same score.
                            The problem wasn't effort. It was that traditional prep doesn't adapt to the individual.
                        </p>
                        <p className={styles.paragraph}>
                            That's when I decided to build the tool I wished I had for every student who walked through my door.
                            Prepal isn't a tech experiment as it's the culmination of thousands of hours of real tutoring experience,
                            packaged into a system that's always available, always patient, and always adapting to you.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUsStory;
